import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { RootState } from "model/state";
import { Dispatch } from "redux";
import { PuckThresholdsModal } from "components";
import {
  selectIsSubmittingThresholds,
  selectThresholdSettings,
} from "selectors/Settings";
import {
  ThresholdSettings,
  Location,
  Device,
  DeviceHardwareThresholds,
} from "model";
import {
  fetchThresholdSettings,
  updateThresholdsSettings,
  updateDevice,
  clearMessage,
} from "actions";
import { selectHasErrorMessage } from "selectors";

type SelectedValues = {
  isSubmitting: boolean;
  thresholds: ThresholdSettings | null;
  hasError: boolean;
};

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmittingThresholds(),
  thresholds: selectThresholdSettings(),
  hasError: selectHasErrorMessage(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSave: () => {},
  fetchThresholdSettings: (locations: Location[]) =>
    dispatch(fetchThresholdSettings(locations)),
  updateThresholdsSettings: (settings: ThresholdSettings) =>
    dispatch(updateThresholdsSettings(settings)),
  updateDevice: (device: Device, settings: ThresholdSettings) => {
    device.hardwareThresholds = {
      battery: settings.battery,
      batteryEnabled: settings.batteryEnabled,
      humidity: settings.humidity,
      humidityEnabled: settings.humidityEnabled,
      tempEnabled: settings.tempEnabled,
      tempF: settings.tempF,
    } as unknown as DeviceHardwareThresholds;

    dispatch(updateDevice(device.id!, device));
  },
  clearMessage: () => dispatch(clearMessage()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PuckThresholdsModal);
